import { useEffect, useState } from 'react';
import { PopTownMark } from '../components/Brand';
import { Button } from '../components/Button';
import { installable, isStandalone, promptInstall, requestPush } from '../lib/pwa';

const KEY = 'poptown.install.dismissed';

export function InstallPrompt() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(KEY) === '1') return undefined;
    const t = window.setTimeout(() => setShow(installable()), 1500);
    return () => window.clearTimeout(t);
  }, []);

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        left: 12,
        right: 12,
        bottom: 68,
        zIndex: 400,
        background: 'var(--panel)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--r-xl)',
        boxShadow: 'var(--shadow-2)',
        padding: 14,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}
    >
      <PopTownMark size={36} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="t-strong">Installa PopTown</div>
        <div className="t-caption dim">Notifiche push e apertura a schermo pieno.</div>
      </div>
      <Button
        size="sm"
        variant="primary"
        icon="download"
        onClick={async () => {
          const ok = await promptInstall();
          if (ok) await requestPush();
          setShow(false);
        }}
      >
        Installa
      </Button>
      <Button
        variant="icon"
        icon="x"
        aria-label="Chiudi"
        onClick={() => {
          localStorage.setItem(KEY, '1');
          setShow(false);
        }}
      />
    </div>
  );
}
